const KNOWN_AUTHORITIES = [
    "AUTH_WORKFLOW_TEST",
    "AUTH_WORKFLOW_SCHEDULE",
    "AUTH_WORKFLOW_SECURED",
    "AUTH_WORKFLOW_TEMPLATE_TEST",
    "AUTH_WORKFLOW_TEMPLATE_SCHEDULE",
    "AUTH_WORKFLOW_TEMPLATE_SECURED",
    "AUTH_FILESHARE_CREATE",
    "AUTH_FILESHARE_VIEW",
    "AUTH_FILESHARE_EDIT",
    "AUTH_FILESHARE_DELETE",
] as const;

export type Authority = (typeof KNOWN_AUTHORITIES)[number];

const KNOWN_AUTHORITIES_SET: ReadonlySet<string> = new Set<Authority>(KNOWN_AUTHORITIES);

export function isKnownAuthority(authority: string): authority is Authority {
    return KNOWN_AUTHORITIES_SET.has(authority);
}
